import React, { useEffect, useState } from "react";
import { getMyStudentInfo, getMyTimetable, linkMyStudent, getMyVirtualClasses, joinVirtualClass, leaveVirtualClass } from "./happyschoolApi";

const DAYS = ["Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];
const dayDM = (startDate, n) => {
  if (!startDate) return "";
  const [y, m, d] = String(startDate).split("-").map(Number);
  const dt = new Date(y, m - 1, d + n);
  return `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}`;
};

const HappySchoolStudentPortal = ({ schoolId }) => {
  const [tab, setTab] = useState("info");
  const [info, setInfo] = useState(null);
  const [tt, setTt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    Promise.all([getMyStudentInfo(schoolId), getMyTimetable(schoolId).catch(() => ({ empty: true }))])
      .then(([i, t]) => { setInfo(i); setTt(t); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId]);

  if (loading) return <p>Đang tải...</p>;
  if (error) return <p style={{ color: "#dc2626" }}>{error}</p>;
  if (!info) return <p style={{ color: "#6b7280" }}>Chưa có thông tin học sinh.</p>;
  if (info.notLinked) return <LinkStudentForm schoolId={schoolId} name={info.name} onLinked={() => window.location.reload()} />;

  const cls = info.class || {};
  const st = info.student || {};

  return (
    <div style={{ maxWidth: 1000, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 2px" }}>🎒 Cổng học sinh — {st.name}</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>Lớp {cls.name}{cls.tohop ? ` · ${cls.tohop}` : ""}</p>

      <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
        {[["info", "🧾 Thông tin lớp"], ["diem", "📊 Điểm của tôi"], ["tkb", "🗓️ Thời khoá biểu"], ["nghe", "🛠️ Lớp học nghề"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} style={tab === k ? tabA : tabS}>{l}</button>
        ))}
      </div>

      {tab === "info" && (
        <div style={card}>
          <Row label="Họ và tên" value={st.name} />
          <Row label="Ngày sinh" value={st.dob} />
          <Row label="Giới tính" value={st.gender} />
          <Row label="Mã định danh" value={st.personalId} />
          <Row label="SĐT" value={st.phone} />
          <Row label="Lớp" value={cls.name} />
          <Row label="Loại lớp" value={cls.classType} />
          <Row label="Tổ hợp" value={cls.tohop} />
          <Row label="Phòng học VH" value={cls.room} />
        </div>
      )}

      {tab === "diem" && (
        <div style={card}>
          {(info.exams || []).length === 0 ? <p style={{ color: "#6b7280", margin: 0 }}>Chưa có điểm.</p> : (
            <table style={tbl}>
              <thead><tr><th style={th}>Môn</th><th style={{ ...th, textAlign: "left" }}>Bài kiểm tra</th><th style={th}>Ngày</th><th style={th}>Điểm</th></tr></thead>
              <tbody>
                {info.exams.map((ex) => (
                  <tr key={ex.id} style={ex.isAverage ? { background: "#f0fdfa" } : undefined}>
                    <td style={td}>{ex.subject || "—"}</td>
                    <td style={{ ...td, textAlign: "left", fontWeight: ex.isAverage ? 700 : 400 }}>{ex.title || "—"}</td>
                    <td style={td}>{ex.date || ""}</td>
                    <td style={{ ...td, fontWeight: 700, color: ex.score ? "#0f766e" : "#9ca3af" }}>{ex.score || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {tab === "tkb" && <StudentTimetable tt={tt} />}
      {tab === "nghe" && <VirtualClassesTab schoolId={schoolId} />}
    </div>
  );
};

// Lớp ảo (vd 12A9HN) — HS tự tham gia/rút, không đụng lớp gốc. Chỉ để nhà
// trường quản lý danh sách/điểm danh, không có TKB riêng.
function VirtualClassesTab({ schoolId }) {
  const [list, setList] = useState(null);
  const [error, setError] = useState("");
  const [busyId, setBusyId] = useState("");

  const load = () => {
    getMyVirtualClasses(schoolId).then(setList).catch((e) => setError(e.message));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [schoolId]);

  const toggle = async (vc) => {
    setBusyId(vc.id); setError("");
    try {
      if (vc.joined) await leaveVirtualClass(schoolId, vc.id);
      else await joinVirtualClass(schoolId, vc.id);
      load();
    } catch (e) { setError(e.message); } finally { setBusyId(""); }
  };

  if (error) return <div style={card}><p style={{ color: "#dc2626", margin: 0 }}>{error}</p></div>;
  if (!list) return <div style={card}><p style={{ color: "#6b7280", margin: 0 }}>Đang tải...</p></div>;

  return (
    <div style={card}>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Đăng ký tham gia lớp học nghề — không ảnh hưởng gì tới lớp học chính của bạn, có thể học cả 2.
      </p>
      {list.length === 0 ? (
        <p style={{ color: "#6b7280", margin: 0 }}>Hiện chưa có lớp học nghề nào mở đăng ký.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {list.map((vc) => (
            <div key={vc.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", border: "1px solid #e5e7eb", borderRadius: 10 }}>
              <div style={{ fontWeight: 600 }}>{vc.name}{vc.joined && <span style={{ marginLeft: 8, fontSize: 12, fontWeight: 700, color: "#0f766e" }}>Đã tham gia</span>}</div>
              <button
                type="button"
                onClick={() => toggle(vc)}
                disabled={busyId === vc.id}
                style={vc.joined
                  ? { padding: "7px 14px", border: "1px solid #dc2626", borderRadius: 8, background: "#fff", color: "#dc2626", cursor: "pointer", fontWeight: 600, fontSize: 13 }
                  : { padding: "7px 14px", border: "none", borderRadius: 8, background: "#0ea5a3", color: "#fff", cursor: "pointer", fontWeight: 600, fontSize: 13 }}
              >
                {busyId === vc.id ? "Đang xử lý..." : vc.joined ? "Rút khỏi lớp" : "Tham gia"}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function StudentTimetable({ tt }) {
  if (!tt || tt.empty) return <div style={card}><p style={{ color: "#6b7280", margin: 0 }}>Chưa có thời khoá biểu.</p></div>;
  const sessions = tt.sessions || [];
  // TKB học sinh: KHÔNG hiện tên giáo viên (yêu cầu rõ — chỉ ẩn GV, không
  // ẩn phòng học). Tiết học nghề vẫn hiện tên môn nghề (tiền tố "HN:") kèm
  // phòng học.
  const cellFor = (day, si, g) => {
    const vh = tt.grid[`${day}|${g}`];
    if (vh) return { a: vh[0] };
    const n = tt.nghe[`${day}|${si}`];
    if (n) return { a: `HN: ${n.subject}`, b: n.room || "", nghe: true };
    return null;
  };
  return (
    <div style={card}>
      <div style={{ marginBottom: 8, color: "#6b7280", fontSize: 13 }}>Lớp {tt.className} · Tuần {dayDM(tt.startDate, 0)}–{dayDM(tt.startDate, 5)}{tt.version ? <> · <b>Bản {tt.version}</b>{tt.runTime ? ` · ${new Date(tt.runTime).toLocaleString("vi-VN", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" })}` : ""}{tt.demo ? " (DEMO — xem thử, chưa chính thức)" : " (đã công bố)"}</> : null}</div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ ...tbl, width: "100%" }}>
          <thead>
            <tr>
              <th style={th}>Buổi</th><th style={th}>Tiết</th>
              {DAYS.map((d, i) => (<th key={d} style={th}>{d}<br /><span style={{ fontWeight: 400, color: "#6b7280" }}>({dayDM(tt.startDate, i)})</span></th>))}
            </tr>
          </thead>
          <tbody>
            {sessions.map((ses, si) => (ses.periods || []).map((p, ti) => (
              <tr key={`${si}-${ti}`}>
                {ti === 0 && <td rowSpan={ses.periods.length} style={{ ...td, fontWeight: 700, background: "#f9fafb", verticalAlign: "middle", textTransform: "uppercase" }}>{ses.label}</td>}
                <td style={td}>Tiết {ti + 1}{p.time ? <div style={{ fontSize: 10, color: "#9ca3af" }}>{p.time}</div> : null}</td>
                {DAYS.map((d, day) => {
                  const c = cellFor(day, si, p.global);
                  return (
                    <td key={d} style={{ ...td, minWidth: 100, background: c ? (c.nghe ? "#fef3c7" : "#eff6ff") : "#fff" }}>
                      {c ? (<><div>{c.a}</div>{c.b && <div style={{ color: "#6b7280", fontSize: 11 }}>{c.b}</div>}</>) : ""}
                    </td>
                  );
                })}
              </tr>
            )))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function LinkStudentForm({ schoolId, name, onLinked }) {
  const [lop, setLop] = useState("");
  const [dob, setDob] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async () => {
    if (!lop.trim() || !dob) { setErr("Nhập Lớp và Ngày sinh."); return; }
    setBusy(true); setErr("");
    try { await linkMyStudent(schoolId, lop.replace(/\s+/g, "").toUpperCase(), dob); onLinked(); }
    catch (e) { setErr(e.message); } finally { setBusy(false); }
  };
  return (
    <div style={{ maxWidth: 440, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 4px" }}>🎒 Xác thực học sinh</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Tài khoản <b>{name}</b> chưa được gán vào lớp. Nhập <b>Lớp</b> và <b>Ngày sinh</b> khớp hồ sơ để liên kết & xem điểm/lớp/TKB.
      </p>
      {err && <p style={{ color: "#dc2626" }}>{err}</p>}
      <div style={card}>
        <label style={{ display: "block", marginBottom: 10 }}>
          <span style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#4b5563", marginBottom: 4 }}>Lớp</span>
          <input value={lop} onChange={(e) => setLop(e.target.value)} placeholder="VD: 12A4" autoCapitalize="characters" style={{ width: "100%", padding: 9, border: "1px solid #d1d5db", borderRadius: 8, boxSizing: "border-box" }} />
        </label>
        <label style={{ display: "block", marginBottom: 14 }}>
          <span style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#4b5563", marginBottom: 4 }}>Ngày sinh</span>
          <input type="date" value={dob} onChange={(e) => setDob(e.target.value)} style={{ width: "100%", padding: 9, border: "1px solid #d1d5db", borderRadius: 8, boxSizing: "border-box" }} />
        </label>
        <button onClick={submit} disabled={busy} style={{ padding: "9px 18px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 }}>
          {busy ? "Đang xác thực..." : "Xác thực & liên kết"}
        </button>
      </div>
    </div>
  );
}

const Row = ({ label, value }) => (
  <div style={{ display: "flex", padding: "6px 0", borderBottom: "1px solid #f3f4f6" }}>
    <div style={{ width: 160, color: "#6b7280", fontSize: 13 }}>{label}</div>
    <div style={{ fontWeight: 600 }}>{value || "—"}</div>
  </div>
);

const card = { border: "1px solid #e5e7eb", borderRadius: 12, padding: 18, background: "#fff" };
const tabS = { padding: "8px 14px", border: "1px solid #d1d5db", borderRadius: 999, background: "#fff", color: "#374151", cursor: "pointer", fontWeight: 600, fontSize: 13 };
const tabA = { ...tabS, background: "#0ea5a3", color: "#fff", borderColor: "#0ea5a3" };
const tbl = { borderCollapse: "collapse", fontSize: 13 };
const th = { border: "1px solid #e5e7eb", padding: "6px 8px", background: "#f9fafb", textAlign: "center", whiteSpace: "nowrap" };
const td = { border: "1px solid #e5e7eb", padding: "5px 8px", textAlign: "center", verticalAlign: "top" };

export default HappySchoolStudentPortal;
